import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {WidgetData} from '../../../../../core/shared/widget/widget-data';
import {FilterCriteria} from '../../../../../core/shared/filter/api/filter.criteria';
import {ObjectRequestList} from '../../../../../core/shared/dto/object/request/object-request-list';
import {WidgetFactory} from '../../../../../core/shared/widget/service/widget.factory';
import {WidgetDataParam} from '../../../../../core/shared/widget/widget-data-param';

@Component({
    selector: 'jb-job-instance-details',
    templateUrl: 'jb-job-instance-details.component.html',
    standalone: false
})
export class JbJobInstanceDetailsComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    activeIndex: number = 0;
    @Input() jobInstanceId: number;

    jobInstanceBasicWidget: WidgetData;
    jobInstanceStepExecutionWidget: WidgetData;
    jobInstanceParametersWidget: WidgetData;

    constructor() {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshWidgets();
        this.initialized = true;
    }

    refreshBasicDetailWidget() {

        const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.jobInstanceId);
        const objectRequestList = ObjectRequestList.createBasic(true, [filterCriteria], []);

        this.jobInstanceBasicWidget = WidgetFactory.createWidget(
            'jb.job.instance.basic.details.list.report.widget',
            'Basic Details',
            'list',
            'list',
            'report',
            'jb.run.3',
            WidgetDataParam.create('objectId', this.jobInstanceId)
        );
        this.jobInstanceBasicWidget.dataProviderListRequest = objectRequestList;
    }

    refreshWidgets() {

        this.refreshBasicDetailWidget();

        const filterCriteria = FilterCriteria.create('job_instance_id', FilterCriteria.cOperatorEqual, this.jobInstanceId);
        const objectRequestList = ObjectRequestList.createBasic(true, [filterCriteria], []);

        this.jobInstanceStepExecutionWidget = WidgetFactory.createWidget(
            'jb.job.instance.step.execution.report.widget',
            'Step Execution',
            'table',
            'list',
            'report',
            'jb.run.4'
        );
        this.jobInstanceStepExecutionWidget.dataProviderListRequest = objectRequestList;

        this.jobInstanceParametersWidget = WidgetFactory.createWidget(
            'jb.job.instance.parameters.report.widget',
            'Parameters',
            'table',
            'list',
            'report',
            'jb.run.5'
        );
        this.jobInstanceParametersWidget.dataProviderListRequest = objectRequestList;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes['jobInstanceId']) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
